var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from 'react';
import './Astronauts.css';
import { Box, Button, Container, Heading, Flex, Spinner } from '@chakra-ui/react';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import CardPreview from './Card/CardPreview';
import useDrag from './useDrag';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
var elemPrefix = 'test';
var getId = function (index) { return "".concat(elemPrefix).concat(index); };
var getItems = function () {
    return Array(10)
        .fill(0)
        .map(function (_, ind) { return ({ id: getId(ind) }); });
};
var Astronauts = function (props) {
    var items = useState(getItems)[0];
    var _a = useState([]), astronauts = _a[0], setAstronauts = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(true), isMore = _c[0], setIsMore = _c[1];
    // NOTE: for drag by mouse
    var _d = useDrag(), dragStart = _d.dragStart, dragStop = _d.dragStop, dragMove = _d.dragMove, dragging = _d.dragging;
    var handleDrag = function (_a) {
        var scrollContainer = _a.scrollContainer;
        return function (ev) {
            return dragMove(ev, function (posDiff) {
                if (scrollContainer.current) {
                    scrollContainer.current.scrollLeft += posDiff;
                }
            });
        };
    };
    var particlesInit = function (main) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadFull(main)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var particleParams = require('../../../assets/particlesjs-config.json');
    function fetchAstronauts(start, limit) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, fetch("https://lldev.thespacedevs.com/2.2.0/astronaut/?limit=".concat(limit, "&offset=").concat(start))
                        .then(function (response) {
                        if (!response.ok) {
                            throw new Error(response.statusText);
                        }
                        return response.json();
                    })
                        .then(function (data) {
                        return data;
                    })];
            });
        });
    }
    function fetchMore() {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        fetchAstronauts(astronauts.length, 10).then(function (result) {
            console.log(result.results);
            if (result.results.length === 0) {
                setIsMore(false);
                return;
            }
            var data = astronauts;
            result.results.map(function (astronaut) {
                data.push(astronaut);
            });
            setAstronauts(data);
            setIsLoading(false);
        });
    }
    function onWheel(apiObj, ev) {
        var isTouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;
        console.log(isTouchpad);
        if (isTouchpad) {
            ev.stopPropagation();
            return;
        }
        if (ev.deltaY < 0) {
            apiObj.scrollNext();
        }
        else if (ev.deltaY > 0) {
            apiObj.scrollPrev();
        }
    }
    useEffect(function () {
        setIsLoading(true);
        fetchAstronauts(1, 10).then(function (result) {
            setAstronauts(result.results);
            setIsLoading(false);
        });
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Container, __assign({ zIndex: '-99', position: "absolute" }, { children: _jsx(Particles, { id: "tsparticles", init: particlesInit, options: particleParams }) })), _jsxs(Flex, __assign({ justifyContent: "center", alignItems: 'center', flexDirection: "column", height: '85vh' }, { children: [_jsx(Heading, __assign({ className: "title", fontSize: '8xl' }, { children: "Astronauts" })), _jsxs(Box, __assign({ height: '50vh', w: "90%", onMouseLeave: dragStop, className: "scroll" }, { children: [isLoading ? (_jsx(Box, __assign({ w: '100%', h: '50vh', justifyContent: "center", alignItems: 'center', display: "flex" }, { children: _jsx(Spinner, {}) }))) : (_jsx(ScrollMenu, __assign({ onWheel: onWheel, onMouseDown: function () { return dragStart; }, onMouseUp: function () { return dragStop; }, onMouseMove: handleDrag }, { children: astronauts.map(function (astronaut, index) { return (_jsx(CardPreview, { name: astronaut.name, avatar: astronaut.profile_image, itemId: index.toString(), agency: astronaut.agency.name, status: astronaut.status.name, bio: astronaut.bio, wiki: astronaut.wiki }, astronaut.name)); }) }))), _jsx(Flex, __assign({ w: "100%", justifyContent: 'center', alignItems: "center", my: 5 }, { children: _jsx(Button, __assign({ isLoading: isLoading, onClick: fetchMore }, { children: "Load More" })) }))] }))] }))] }));
};
export default Astronauts;
